"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Footer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _commonElements = require("./commonElements");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterContainer = _styledComponents.default.div.withConfig({
  displayName: "Footer__FooterContainer",
  componentId: "v8zxkr-0"
})(["display:", ";flex-direction:column;"], function (props) {
  return props.inline ? "inline" : "flex";
}); // TODO: Remove twitter logic once deprecated


var Footer = function Footer(props) {
  var onFacebookLogin = props.onFacebookLogin,
      handleTypeChange = props.handleTypeChange,
      mode = props.mode,
      inline = props.inline;

  switch (mode) {
    case "login":
      {
        return _react.default.createElement(FooterContainer, {
          inline: inline
        }, _react.default.createElement(_commonElements.SmallText, null, "Log in using ", _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: onFacebookLogin
        }, "Facebook"), ". "), _react.default.createElement(_commonElements.SmallText, null, " Don’t have an account? ", _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: function onClick() {
            return handleTypeChange("signup");
          }
        }, "Sign up.")));
      }

    case "forgot":
      {
        return _react.default.createElement(FooterContainer, {
          inline: inline
        }, _react.default.createElement(_commonElements.SmallText, null, "Don’t need to reset? ", _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: function onClick() {
            return handleTypeChange("login");
          }
        }, "Log in"), " or ", _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: function onClick() {
            return handleTypeChange("signup");
          }
        }, "sign up.")));
      }

    default:
      {
        return _react.default.createElement(FooterContainer, {
          inline: inline
        }, _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: onFacebookLogin
        }, "Sign up using Facebook."), _react.default.createElement(_commonElements.SmallText, null, " Already have an account? ", _react.default.createElement(_commonElements.SmallTextLink, {
          onClick: function onClick() {
            return handleTypeChange("login");
          }
        }, "Log in.")));
      }
  }
};

exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map